export const pageTitle = title => {
  return (document.title = title + ' - Premium Men\'s Vitality Supplement by Ayumedix');
};
